import React, { useEffect } from 'react';

import AppLocale from 'lngProvider';
import { ConfigProvider } from 'antd';
import { IntlProvider } from 'react-intl';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { NotificationContainer } from 'react-notifications';

import moment from 'moment';
import 'moment/locale/es';
import esES from 'antd/es/locale/es_ES';
import enUS from 'antd/es/locale/en_US';

import 'packages/styles';
import GlobalEmergencyAlerts from '@src/packages/emergencies/components/GlobalEmergencyAlerts';
import { WORK_DIRECTION } from './constants';
import OperondaApp from './OperondaApp';
import TimeTrackerApp from './TimeTracker/TimeTrackerApp';
import AuthProvider from './TimeTracker/contexts/AuthProvider';
import { TimeTrackerProvider } from './TimeTracker/contexts/TimeTrackerProvider';
import { ReportProvider } from './TimeTracker/Main/contexts/ReportContext';

const App = () => {
  const { locale } = useSelector(({ settings }) => settings);
  const location = useLocation();
  const { pathname } = location;
  const isWorkAddress = Boolean(pathname.match(`/${WORK_DIRECTION}`));

  // Fallback to Spanish if locale is not supported
  const currentAppLocale = AppLocale[locale.locale] || AppLocale.es;

  // Handle antd locale configuration with fallback
  const getAntdLocale = () => {
    switch (currentAppLocale.locale) {
      case 'es':
        return esES;
      case 'en':
      default:
        return enUS;
    }
  };

  // DatePicker month/day names use moment; keep it in sync with UI language.
  useEffect(() => {
    moment.locale(currentAppLocale.locale === 'es' ? 'es' : 'en');
  }, [currentAppLocale.locale]);

  const antdLocale = { locale: getAntdLocale() };

  return (
    <ConfigProvider {...antdLocale}>
      <NotificationContainer />
      <IntlProvider locale={currentAppLocale.locale} messages={currentAppLocale.messages}>
        <GlobalEmergencyAlerts>
          <TimeTrackerProvider>
            <ReportProvider>
              {!isWorkAddress ? (
                <OperondaApp />
              ) : (
                <AuthProvider>
                  <TimeTrackerApp />
                </AuthProvider>
              )}
            </ReportProvider>
          </TimeTrackerProvider>
        </GlobalEmergencyAlerts>
      </IntlProvider>
    </ConfigProvider>
  );
};

export default App;
